import React, { FC } from 'react';
import LoadingSvg from './loading.svg?react';
import style from './style.module.less';
import {
  ChatMessageType,
  ChatMessageWrapper,
  formatLongDateTime,
} from '@law-connect/react-components';

interface Props {
  filesLoading: boolean;
  from: ChatMessageType;
}

export const FileUploading: FC<Props> = (props) => {
  const { filesLoading, from } = props;
  return filesLoading ? (
    <ChatMessageWrapper
      messageBody={
        <>
          <div className={style.loadingContainer}>
            <div className={style.loadingIconContainer}>
              <LoadingSvg className={style.loadingIcon} />
            </div>
            <div className={style.text}>Uploading files</div>
          </div>
        </>
      }
      type={from}
      timestamp={formatLongDateTime(Date.now())}
    />
  ) : null;
};
